import {
  formItemLayout,
  AddressFormField,
  validatePhoneNumber,
  phoneNumberFormattingUtils,
  validatePostcode,
  zipcodeFormattingUtils,
  address1DefaultValueReWrite,
} from './base';

export const addressFormFields: AddressFormField[] = [
  {
    key: 'firstname',
    translationKey: 'firstname',
    type: 'input',
    required: true,
    validation: {
      minLength: 1,
      maxLength: 32,
    },
    layoutStyle: formItemLayout.twoColumn,
  },
  {
    key: 'lastname',
    translationKey: 'lastname',
    type: 'input',
    required: true,
    validation: {
      minLength: 1,
      maxLength: 32,
    },
    layoutStyle: formItemLayout.twoColumn,
  },
  {
    key: 'phone',
    translationKey: 'phone',
    type: 'input',
    required: true,
    validation: { validate: validatePhoneNumber },
    formatter: phoneNumberFormattingUtils.UK,
    layoutStyle: formItemLayout.twoColumn,
  },
  {
    key: 'alternatePhone',
    translationKey: 'alternatePhone',
    type: 'input',
    required: false,
    validation: { validate: validatePhoneNumber },
    formatter: phoneNumberFormattingUtils.UK,
    layoutStyle: formItemLayout.twoColumn,
  },
  {
    key: 'address2',
    translationKey: 'address2',
    type: 'input',
    required: false,
    validation: {
      maxLength: 256,
    },
    layoutStyle: formItemLayout.oneColumn,
  },
  {
    key: 'address1',
    translationKey: 'street',
    type: 'input',
    required: true,
    validation: {
      maxLength: 256,
    },
    layoutStyle: formItemLayout.oneColumn,
    defaultValueReWrite: address1DefaultValueReWrite,
  },
  {
    key: 'country',
    translationKey: 'country',
    type: 'input',
    required: true,
    disabled: true,
    value: 'United Kingdom',
    layoutStyle: formItemLayout.oneColumn,
  },
  {
    key: 'city',
    translationKey: 'city',
    type: 'input',
    required: true,
    validation: {
      maxLength: 256,
    },
    layoutStyle: formItemLayout.twoColumn,
  },
  {
    key: 'zipcode',
    translationKey: 'zipcode',
    type: 'input',
    required: true,
    validation: { validate: validatePostcode },
    formatter: zipcodeFormattingUtils.UK,
    layoutStyle: formItemLayout.twoColumn,
  },
  {
    key: 'companyName',
    translationKey: 'companyName',
    type: 'input',
    label: 'Company name (Optional)',
    required: false,
    placeholder: 'Enter Company Name',
    validation: {
      maxLength: 256,
    },
    layoutStyle: formItemLayout.oneColumn,
  },
];
